import { getClientsAndSites, loadConfig } from '@grantstreet/psc-config'
import { clientAndSiteFromUrl } from '@grantstreet/psc-js/utils/client-site.ts'

export async function setupConfig () {
  const { client, site } = clientAndSiteFromUrl()
  await getClientsAndSites()
  await loadConfig({ client, site })
}
